export { default } from './CdnImage';
